import React from 'react';
import CategoryWrapper from '../Category/CategoryWrapper';
import CategoryHeader from '../Category/CategoryHeader';
import CategoryBody from '../Category/CategoryBody';
import ProductVertical from '../ProductVertical';
import { useSelector } from 'react-redux';
import { postsPromotionCodeState$ } from '../../redux/selectors';

export default function PromotionCodePosts() {
  const promotionCodes = useSelector(postsPromotionCodeState$);

  if (!promotionCodes || (promotionCodes && promotionCodes.length === 0)) {
    return null;
  }

  return (
    <CategoryWrapper>
      <CategoryHeader
        left={
          <div style={{ color: '#fd680e' }}>
            <i className="fa fa-scissors"></i>&nbsp;Mã giảm giá
          </div>
        }
      />
      <CategoryBody itemPerRow={5}>
        {promotionCodes && promotionCodes.map(item => {
          const { _id, image, title, ...rest } = item;
          const images = (
            <img
              src={image}
              alt={title}
              width="180"
              height="180"
            />
          );
          return (
            <ProductVertical
              key={_id}
              path={`/promotion-codes/${_id}`}
              promotion={true}
              images={images}
              title={title}
              {...rest}
            />
          )
        })}
      </CategoryBody>
    </CategoryWrapper>
  );
}